import { Color } from "@lib/color";
interface Config{
	isWhiteLabel:boolean;
	branding:{
		vendor:string;
		logo:string;
		reportLogo:string;
		favIcon:string;
	},
	themes:{
		primaryColor:string;
		reports:{
			stripBar1Color:string;
			stripBar3Color:string;
		}
	},
	support:{
		supportEmail:string;
		supportDeskDetails:{
			departmentId:string;
			layoutId:string;
			widgetId:string;
			orgId:string;
		}
	}
}

export const environment = {
	production: false,
	name: '',
	parentUrl: '',
	accountsLoginUrl: 'https://accounts.strayos.com/login.html',
	baseUrl: '',
	apiUrl: 'https://devx.strayos.com:3034/',
	apiPrefix: 'api',
	accountsLoginRedirectUrl() {
		return `${this.accountsLoginUrl}?return_to=${this.baseUrl}&environment=${this.name}&api_url=${this.apiUrl}`
	},
	configs: <Config>{
		isWhiteLabel: false,
		branding: {
			vendor: 'Strayos',
			logo: 'https://s3downloadcdn.strayos.com/whitelabels/strayos/logo.svg',
			reportLogo: 'https://s3downloadcdn.strayos.com/whitelabels/strayos/report-logo.png',
			favIcon: 'https://s3downloadcdn.strayos.com/whitelabels/strayos/favicon.ico',
		},
		themes: {
			primaryColor: '#5271ff',
			reports: {
				stripBar1Color: '#5355ff',
				stripBar3Color: '#4f92ff'
			}
		},
		support: {
			supportEmail: 'support@strayos.com',
			supportDeskDetails: {
				departmentId: '940019000000006907',
				layoutId: '940019000000074011',
				widgetId: '940019000001151373',
				orgId: '841237884'
			}
		}
	},
	primaryColor(){
		const color=this.configs.themes.primaryColor;
		return Color.html(color);
	}
};
